import {forEach} from 'lodash';

/**
 * Polyfill for domnode.remove() (https://www.w3.org/TR/dom/#dom-childnode-remove)
 */
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

export const resolveEnvironment = (window) => {
  const navigator = window.navigator;
  const document = window.document;

  const BROWSER_TEST_CASES = {
    Explorer: [
      /MSIE (\d+\.?\d+)/,
      /Trident.+rv:(\d+\.?\d+)/
    ],
    Firefox: [
      /Firefox\/(\d+)/
    ]
  };

  function getBrowserInfo () {
    let browser = '';
    let version = NaN;

    forEach(BROWSER_TEST_CASES, (tests, name) => {
      tests.some(test => {
        const [, v] = navigator.userAgent.match(test) || [];
        if (v) {
          browser = name;
          version = v;
          return true;
        }
      });
    });

    return {browser, version};
  }

  const OS_TEST_CASES = {
    iOS: [
      /iPad|iPhone|iPod/i
    ]
  };

  function getOsInfo () {
    let os = '';
    forEach(OS_TEST_CASES, (tests, name) => {
      tests.some(test => {
        if (test.test(navigator.userAgent)) {
          os = name;
          return true;
        }
      });
    });
    return os;
  }

  // Features
  const supportsCanvas = !!document.createElement('canvas').getContext;
  // Browser Info
  const {browser, version} = getBrowserInfo();
  const OS = getOsInfo();

  const isIE = browser.indexOf('Explorer') > -1;
  const isFirefox = browser.indexOf('Firefox') > -1;
  const isIEBelow9 = isIE && (isNaN(version) || version < 9);
  const isIOS = OS === 'iOS';

  return {
    supportsCanvas,
    isIE,
    isFirefox,
    isIEBelow9,
    isIOS
  };
};

export const env = resolveEnvironment(window);



// WEBPACK FOOTER //
// ./src/uScope/js/lib/utility/browser-compatibility.js